import * as _ from "underscore";
import * as utils from "./utils.js";

const getDateFromObjectId = (objectId) => {
  objectId = objectId.toString();

  const seconds = parseInt(objectId.substring(0, 8), 16);
  const date = new Date(seconds * 1000);

  return date.toISOString();
};

const getContext = (userWord) => {
  let context;
  if (userWord.contexts && userWord.contexts.length > 0) {
    context = userWord.contexts[0];
    if (context) {
      context = context.text;
    }
  } else {
    context = userWord.context;
  }
  return context || "No Context";
};

const getField = {
  contextBlanked: function (model) {
    const word = model.word;
    const context = getContext(model) || word;

    const result = context.replace(
      new RegExp(utils.regexpEscape(word), "i"),
      "______"
    );

    return result;
  },
  contextWithTranslation: function (model) {
    const word = model.word;
    const context = getContext(model) || word;
    const translation = model.translation;

    const result = context.replace(
      new RegExp(utils.regexpEscape(word), "i"),
      "[[" + translation + "]]"
    );

    return result;
  },
  contextAnkiClozeOriginal: function (model) {
    const word = model.word;
    const context = getContext(model) || word;

    const result = context.replace(
      new RegExp(utils.regexpEscape(word), "i"),
      "{{c1::" + word + "}}"
    );

    return result;
  },
  contextAnkiClozeBoth: function (model) {
    const word = model.word;
    const context = getContext(model) || word;
    const translation = model.translation;

    const result = context.replace(
      new RegExp(utils.regexpEscape(word), "i"),
      "{{c1::" + word + "::" + translation + "}}"
    );

    return result;
  },
  contextWithOriginal: function (model) {
    const word = model.word;
    const context = getContext(model) || word;

    const result = context.replace(
      new RegExp(utils.regexpEscape(word), "i"),
      "[[" + word + "]]"
    );

    return result;
  },
  alternativeTranslations: function (model) {
    return (model.alternativeTranslations ?? []).join(" / ");
  },
  alternativeWords: function (model) {
    return (model.alternativeWords ?? []).join(" / ");
  },
  dateCreated: function (model) {
    return getDateFromObjectId(model._id);
  },
  source: function (model) {
    let context = {};

    if (model.contexts && model.contexts.length > 0) {
      context = model.contexts[0];
    }

    if (context.bookID) {
      return context.bookID.title || "<Document Title>";
    } else {
      return context.URL || "Source Unknown";
    }
  },
  sourceUrl: function (model) {
    const context = model.contexts?.[0];
    if (context === undefined) {
      return "No Source URL";
    }

    if (context.bookID?._id) {
      return `https://readlang.com/library/${context.bookID._id}`;
    }

    return context.URL ?? "No Source URL";
  },
};

let delimiter;
let delimiterRegexp;
let delimiterReplace;

export const formatWord = (word, fields, _delimiter) => {
  const formattedWords = [];

  const contexts =
    word.contexts.length > 0 ? word.contexts : [{ text: "No context" }];

  // expand word into separate word for each context
  for (const context of contexts) {
    const strippedWord = _.chain(word)
      .omit("contexts")
      .extend({ contexts: [context] })
      .value();
    formattedWords.push(formatContext(strippedWord, fields, _delimiter));
  }

  return formattedWords;
};

// uses the 1st context in the word only
const formatContext = (word, fields, _delimiter) => {
  const line = [];

  if (delimiter !== _delimiter) {
    delimiter = _delimiter;
    let escapedDelimiter = "";
    _.each(delimiter, (char) => {
      escapedDelimiter += "\\" + char;
    });
    delimiterRegexp = new RegExp(escapedDelimiter, "g");
    delimiterReplace = escapedDelimiter;
  }

  _.each(fields, (field) => {
    let fieldText;
    if (getField[field]) {
      fieldText = getField[field](word);
    } else {
      if (word[field]) {
        fieldText = word[field].toString();
      } else {
        fieldText = "undefined";
      }
    }
    line.push(
      fieldText
        .replace(delimiterRegexp, delimiterReplace)
        .replace(/\n|\r|\t/g, " ")
    );
  });

  return line.join(delimiter);
};
